define('models/SidedishModel',['underscore','ObjectModel','app','formatPrice',
        'hooks',
        'sprintf',
        'template!blocks/product/sidedish-block',
        'template!blocks/product/sidedishes-default',
        'template!blocks/product/sidedishes-list-grouped',
        'template!blocks/product/sidedishes-custom-box-42',
    ],function (_,ObjectModel,app,formatPrice,
        hooks,
        sprintf,
        sidedishBlockTemplate,
        templateSidedishesDefault,
        templateSidedishesListGrouped,
        templateSidedishCustomBox42
        ) {

    var CUSTOM_BOX_42_LOCATIONS = _([
        {id:'A',type:'rolls',o:'h',x:248,y:200,z:6},
        {id:'B',type:'rolls',o:'h',x:552,y:200,z:7},
        {id:'C',type:'rolls',o:'v',x:400,y:400,z:1},
        {id:'D',type:'rolls',o:'h',x:248,y:600,z:8},
        {id:'E',type:'rolls',o:'h',x:552,y:600,z:9},
        {id:'F',type:'rolls-div',o:'v',x:178,x_alt:622,y:400,z:2},
        {id:'G',type:'sushis-div',o:'v',x:400,y:160,y_alt:640,z:5},
        {id:'H',type:'sushis',o:'v',x:268,y:400,z:4},
        {id:'I',type:'sushis',o:'v',x:532,y:400,z:3},
    ]);

    var CUSTOM_BOX_LOCATION_BASE_W=184,
        CUSTOM_BOX_LOCATION_BASE_H=276;
    CUSTOM_BOX_42_LOCATIONS.each(function(location){
        var type=location.type,
            baseType = type.replace(/\-div$/,''),
            pScale = 100 / 800,
            orientation = location.o,
            horizontal = orientation==='h',
            a = horizontal ? 90:0,
            x = location.x || 0,
            y = location.y || 0,
            x_alt = location.x_alt || x,
            y_alt = location.y_alt || y,
            isDivided = /\-div$/.test(type),
            W,H,
            bounds = [];
        W = horizontal ? CUSTOM_BOX_LOCATION_BASE_H : CUSTOM_BOX_LOCATION_BASE_W;
        H = horizontal ? CUSTOM_BOX_LOCATION_BASE_W : CUSTOM_BOX_LOCATION_BASE_H;
        if(isDivided){
            W/=2
        }
        function pushBounds(useAlt){
            var boundX = useAlt ? x_alt : x,
                boundY = useAlt ? y_alt : y,
                left = boundX-W/2,
                top = boundY-H/2,
                style =
                    'top:'+(top*pScale)+'%;'+
                    'left:'+(left*pScale)+'%;'+
                    'width:'+(W*pScale)+'%;'+
                    'height:'+(H*pScale)+'%;'
                ;
            bounds.push({
                right:boundX+W/2,
                left:left,
                top:top,
                bottom:boundY+H/2,
                width:W,
                height:H,
                style:style
            })
        }
        pushBounds(false);
        if(isDivided) pushBounds(true);
        location.bounds = bounds;
    });

    //
    // Model Sidedish
    //
    var SidedishModelPrototype = {

        name:'SidedishModel',
        idAttribute:'id_cross_selling',
        defaults:function(){
          return {
              'selection':[],
          }
        },
        initialize:function(){
            var model = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model,arguments);
            //
            if(!model.get(model.idAttribute)){
                model.attributes[model.idAttribute] = model.get('id');
            }
        },
        getDisplayPlus:function() {
            return this.get('display_plus');
        },
        getDefaultValue:function() {
            return this.get('id_product_default');
        },
        getErrorDescription:function() {
            return this.get('error_description');
        },
        getCountdownDescription:function() {
            var message = this.getErrorDescription();
            var string = '<span class="countdown">' + this.getMinimum() + '</span>';
            return sprintf.vsprintf(message, string);
        },
        getTemplateName:function() {
            return this.get('template');
        },
        getTemplate:function () {
            var model = this,
                templateName = model.getTemplateName(),
                template = templateSidedishesDefault;

            switch (templateName) {
                case 'grouped_list':
                    template = templateSidedishesListGrouped;
                    break;
                case 'custom_box_42':
                    template = templateSidedishCustomBox42;
                    break;
                default:
                if(templateName){
                    template = window.templates[templateName];
                    if(!template) template = templateSidedishesDefault;
                }
            }
            hooks.execHook('getSidedishTemplate',templateName,function(tpl){
                template = tpl;
            });
            return template;
        },
        execTemplate:function(index, product, isCartProduct){
            var sidedish = this,
                template = sidedish.getTemplate();
            return template({
                index:index,
                product:product,
                sidedish:sidedish,
                key:'sidedish' + sidedish.id,
                products:sidedish.getCategoryProducts(),
                title:sidedish.getTitle(),
                isCartProduct: isCartProduct
            });
        },
        isRoot:function(){
            return this.get('id_parent') === '0';
        },
        getChild:function(id){
            return this.getChildren().findWhere({id: id});
        },
        getChildren:function(){
            return this.collection.filtredChild(this.id);
        },
        eachChildren:function(iteratee){
            this.getChildren().each(iteratee);
        },
        // catégorie produit associée
        getCategory:function(){
            return app.getCategory(this.get('id_category'));
        },
        getCategoryName:function(){
            var category = this.getCategory();
            return category ? category.getName() : ' - ';
        },
        getCategoryDescription:function(){
            var category = this.getCategory();
            return category ? category.getDescription() : ' - ';
        },
        getTitle:function(){
            return this.get('title') || this.getCategoryName();
        },
        formatTitle:function(){
            var model = this,
                title = model.getTitle(),
                url = model.get('url');
            if(url){
                title = '<a href="'+url+'" target="_blank">'+title+'</a>';
            }
            return title;
        },
        getDescription:function(){
            return this.get('description') || this.getTitle();
        },
        getButtonCancel:function(){
            return this.get('button_cancel') || false;
        },
        getButtonOk:function(){
            return this.get('button_ok') || false;
        },
        getCategoryProducts:function(){
            var category = this.getCategory();
            return category ? category.getProducts(true) : _([]);
        },
        getMinimum:function(){
            return parseInt(this.get('quantity_min')) || 0;
        },
        getMaximum:function(){
            return parseInt(this.get('quantity_max')) || Infinity;
        },
        getMaximumProduct:function(id_product){
            var max = _(this.get('id_product_max')).reduce(function(memo,id){
                return memo + (id==id_product?1:0)
            },0);
            return max>0?max:Infinity;
        },
        isFixedProduct:function(id_product){
            // la quantité peut être fixé
            var model = this,
                immutableQty = model.getSelectionQuantity(id_product, true),
                maxQty = model.getMaximumProduct(id_product);
            return maxQty===immutableQty;
        },
        getProduct:function(id_product){
            // alias
            return app.getProduct(id_product);
        },
        getRulesLabel:function(){
          var label = '',
              model = this,
              PERFERCT_LABEL = 'C’est parfait !',
              isRoot = model.isRoot();
          if(isRoot){
              var missing = [], missingProducts;
              model.eachChildren(function(sidedish){
                  var qty = sidedish.getSelectionQuantity(),
                      max = sidedish.getMaximum(),
                      qtyDiff = max - qty;
                    if(qtyDiff>0) missing.push(qtyDiff+' '+sidedish.getTitle());
              })
              if(missing.length){
                  var last = missing.pop();
                  missingProducts = missing.join(', ');
                  if(last){
                      missingProducts = (!!missingProducts ? missingProducts+' '+app.t('et','UI')+ ' ' : '') +last;
                  }
                  label = app.t('Encore %s à sélectionner','Product',missingProducts);
              }else{
                  label = model.getButtonOk() || app.t(PERFERCT_LABEL,'Product');
              }
          }else{
              var qty = model.getSelectionQuantity(),
                  max = model.getMaximum(),
                  min = model.getMinimum(),
                  required = model.isRequired() || (min === max),
                  qtyDiff = max - qty,
                  diffPlural = qtyDiff>1;
              if(qty===max){
                  label = model.getButtonOk() || app.t(PERFERCT_LABEL,'Product');
              }else if(required || max > 0){
                  label = app.t( 'Ajoutez encore %s produit'+(diffPlural?'s':''),'Product', qtyDiff);
              }
          }
            return label;
        },
        getIsMultipleByProduct:function(){
            return !!this.get('multiple_by_product') && (this.getMaximum()>1);
        },
        selectionContains:function(product){
            var selection = this.get('selection');
            if(selection){
                return _(selection).contains(product.id);
            }
            return false;
        },
        selectionContainsId:function(id_product){
            var model = this,
                selectionContainsId = _(model.get('selection')).contains(id_product)
            return selectionContainsId;
        },
        selectionChecked:function(id_product){
            return this.getSelectionQuantity(id_product) > 0 ? 'checked':'';
        },
        selectionAttrValue:function(id_product){
            // attribut html de la valeur selectionnée
            var attr, model = this, max = model.getMaximum(),
                key = 'sidedish'+model.id;
            attr = 'id="sidedish-'+ key +'-'+id_product+'" '
            if(model.getIsMultipleByProduct()){
                attr += ' value="'+(model.getSelectionQuantity(id_product))+'"';
                attr += ' min="0" step="1" max="'+max+'"';
                attr += ' name="sidedish-'+key+'-'+id_product+'"';
            }else{
                attr += model.selectionChecked(id_product)
                attr += ' name="sidedish-'+key+'"';
            }
            return attr;
        },
        getCapability:function(id_product,cap){
            var model = this,
                qty = model.getSelectionQuantity(id_product),
                single_by_product = (!!id_product && !model.getIsMultipleByProduct()),
                qtyTotal = single_by_product ? 0 : model.getSelectionQuantity(),
                qtyImmutable = model.getSelectionQuantity(id_product,true),
                isStockout = !!id_product && model.getProduct(id_product).isStockout(),
                max = single_by_product ? 1 : model.getMaximum(),
                maxByProduct = !!id_product ? Math.min(max,model.getMaximumProduct(id_product)) : max,
                canAddTotal = qtyTotal < max,
                canAdd = canAddTotal && (!id_product || (qty < maxByProduct)),
                canRemove = qty > qtyImmutable,
                capTest = false;
            if(isStockout){
                // noop
            }else if(cap==='add'){
                capTest = canAdd;
            }else if(cap==='remove'){
                capTest = canRemove;
            }
           return capTest ? 'yes':'no';
        },
        getSelection:function(){
            return this.get('selection') || [];
        },
        getSimplifiedSelection:function(){
           return _(this.getSelection().filter(function(item){
               return item.quantity > 0
           })).map(function(item){return {
               id:item.id,
               quantity:item.quantity
           }})
        },
        getLocations:function(){
            return CUSTOM_BOX_42_LOCATIONS;
        },
        getSelectionQuantity:function(id_product,immutable){
            // permet d'obtenir la quantité totale, ou immutable d'un produit de la selection,
            // ou de l'ensemble de la selection.
            var selection = this.getSelection(), qty = 0;
            _(selection).each(function(s){
                if(!id_product || s.id===id_product){
                    qty += immutable ? s.immutable : s.quantity;
                }
            });
            return qty;
        },
        getSelectionPrice:function(){
            var selection = this.getSelection(), price = 0;
            if(!this.isFree()){
                _(selection).each(function(s){
                    var product = s.p, qty = s.quantity;
                    if(product && qty>0){
                        price += qty * product.getPrice('ttc',true);
                    }
                });
            }
            return price;
        },
        getSelectionCartProducts:function(){
            return app.getProducts().getProductsByIds(this.getSelection());
        },
        isStockout:function(){
            // retourne true si un des produits de la selection est en rupture de stock
            var isStockout = false;
            this.getSelectionCartProducts().each(function(product){
                isStockout = isStockout || product.isStockout();
            });
            return isStockout;
        },
        validateSelection:function(){
            var model = this,
                required = model.isRequired(),
                validate = !required,
                children = model.getChildren(),
                max = model.getQuantityMax(),
                min = model.getQuantityMin(),
                quantity = 0;
            if(children.size()){ // si il y a des enfants, on vérifie la selection des enfants
                validate = true;
                _(children).each(function(sidedishChild){
                   validate = validate && sidedishChild.validateSelection();
                });
            }else if(required || min > 0){ // sinon, si c'est requis
                quantity = model.getSelectionQuantity();
                validate = (quantity >= (min || 1)) && (quantity <= max);
            }
            return !!validate;
        },
        getEmptiness:function(){
            var model = this,
                children = model.getChildren(),
                quantity = 0;
            if(children.size()) {
                children.each(function (sidedish) {
                    quantity += sidedish.getSelectionQuantity();
                })
            }else{
                quantity = model.getSelectionQuantity()
            }
            return !(quantity > 0);
        },
        shiftSelection:function(){
            var selection = this.getSelection(),
                shifted = false, unshifted = [];
            while(!shifted){
                shifted = selection.shift();
                if(shifted.quantity > shifted.immutable || 0){
                    shifted.quantity --;
                    if(shifted.quantity > 0){
                        unshifted.push(shifted);
                    }
                }else if(shifted && shifted.quantity > 0){
                    // cas selection mémorisée avec "quantité nulle"
                    unshifted.push(shifted);
                    shifted = false;
                }
            }
            _(unshifted).each(function(s){
                selection.unshift(s);
            })
            return shifted;
        },
        changeSelection:function(add,id_product){
            var model = this,
                currentQuantity = model.getSelectionQuantity(id_product),
                newQuantity = currentQuantity+(add?1:-1);
            return model.updateSelection(newQuantity,id_product)
        },
        updateSelection:function(quantity,id_product){
            var model = this,
                selection = model.getSelection(),
                currentSelection = _(selection).findWhere({id:id_product}),
                allPositions = model.get('pos_custom_box'),
                diffQty = quantity - (!!currentSelection ? currentSelection.quantity : 0),
                add = diffQty > 0,
                filledPositions = _.flatten(_(selection).pluck('positions')),
                availablePositions = _.difference(allPositions,filledPositions);

            if(!currentSelection){
                currentSelection = {
                    id:id_product,
                    quantity: 0,
                    default:0,
                    immutable:0,
                    p:app.getProduct(id_product),
                    positions:[],
                };
                selection.push(currentSelection);
            }

            var positions = currentSelection.positions;
            for(var i=0; i<Math.abs(diffQty); i++){
                if(!add){
                    positions.pop();
                }else{
                    positions.push(availablePositions[i] || '*');
                }
            }
            currentSelection.quantity = quantity;
            return currentSelection;
        },
        // fillRandom: function(){
        //     // remplir aléatoirement la selection.
        //     var model = this;
        //     model.eachChildren(function(sidedish){
        //         var selection = sidedish.getSelection(),
        //             immutableQty = sidedish.getSelectionQuantity(false,true),
        //             qty = 0,
        //             multiple_by_product = sidedish.getIsMultipleByProduct(),
        //             max = sidedish.getMaximum(),
        //             pos_custom_box = _(sidedish.get('pos_custom_box')||[]).clone();
        //         // reset les quantités et positions
        //         _(selection).each(function(sel){
        //             sel.quantity = sel.immutable || 0;
        //             sel.positions = sel.positions.slice(0,sel.immutable);
        //             pos_custom_box = _.difference(pos_custom_box,sel.positions);
        //         });
        //
        //         function shiftPosition(){
        //             var shift = pos_custom_box.shift() || '*';
        //             return shift;
        //         }
        //
        //         var products = sidedish.getCategoryProducts(), maxLoop = 0;
        //         if(max !== Infinity && !!products.length){
        //             while(qty<max-immutableQty){
        //                 maxLoop ++;
        //                 if(maxLoop>1000) break; // sécurité pour des cas improbables, mais réels
        //                 // par exemple, si le cross sell est limité à 1 quantité par produit,
        //                 // et qu'il y a moins de produit que le minimum requis
        //                 // etc...
        //                 var product = products.at(Math.floor(Math.random()*products.length));
        //                 if(product && product.isBuyableInContext()){
        //                     var id_product = product.id,
        //                         currentSelection = _(selection).findWhere({id: id_product});
        //                     if (!currentSelection) {
        //                         currentSelection = createSelectionItem(id_product, 1, 1, 0,shiftPosition);
        //                         selection.push(currentSelection)
        //                     } else {
        //                         var currentQty = currentSelection.quantity;
        //                         if(currentQty && (!multiple_by_product || (currentQty>=sidedish.getMaximumProduct(id_product)))) continue;
        //                         currentSelection.positions.push(shiftPosition());
        //                         currentSelection.quantity += 1;
        //                     }
        //                     qty ++;
        //                 }
        //             }
        //         }
        //     })
        // },
        // quantité maximale
        getQuantityMax:function(){
            return this.get('quantity_max') || Infinity;
        },
        getQuantityMin:function(){
            return this.get('quantity_min') || 0;
        },
        isRequired:function(){
            return this.get('quantity_min') > 0;
        },
        isFreeDisplay:function(){
            return this.get('display_free') === true;
        },
        isPlusDisplay:function(){
            return this.get('display_plus') === true;
        },
        isFree:function(){
            return this.get('is_free') === true;
        },
        isAttached:function(){
            return this.get('is_attached') === true;
        },
        isPack:function(){
            return this.get('is_pack') === true;
        },
        validateGroupedList:function() {
            var min = this.getMinimum(),
                max = this.getMaximum();

            var selectedIds = [];

            // For classic input
            var selected = $('.sidedish-group-'+this.id+' .sidedish-list-grouped__input input:checked');
            if (selected.length >= min && selected.length <= max) {
                selected.each(function() {
                    selectedIds.push($(this).val());
                })
            }

            // For multiple inputs
            var multiple = $('.sidedish-group-'+this.id+' .sidedish-list-grouped__input--multiple input');
            var multipleTotal = 0;
            multiple.each(function() {
                var value = (isNaN(parseInt($(this).val()))) ? 0 : parseInt($(this).val());
                multipleTotal += value;
                if (multipleTotal > 0 && multipleTotal <= max && value) {
                    selectedIds.push({
                        id:$(this).attr('name'),
                        quantity: value,
                    });
                }
            });
            if (multiple.length && (multipleTotal < min || multipleTotal > max)) {
                selectedIds = [];
            }
            return selectedIds;
        }
    };


    function createSelectionItem(id_product, qty, defaultQty, immutableQty, shiftPosition) {
        var positions = [], product = app.getProduct(id_product), invalid = false;
        if(product && !product.isBuyableInContext()){
            // si le produit n'est pas disponible, on affecte pas de quantité
            if(immutableQty) invalid = true;
            qty = defaultQty = immutableQty = 0;
        }

        for (var i = 0; i < qty; i++) positions.push(shiftPosition());

        return {
            id: id_product,
            p: product,
            quantity: qty,
            default: defaultQty,
            immutable: immutableQty,
            positions: positions,
            invalid: invalid,
        }
    }

    var SidedishModel = ObjectModel.extend(SidedishModelPrototype);

    SidedishModel.createSelectionItem = createSelectionItem;

    return SidedishModel;
});
